// src/App.js
import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Contexts
import { LanguageProvider } from './common/contexts/LanguageContext';

// Landing
import LandingPage from './landing/pages/LandingPage';
import LegalPage   from './landing/pages/LegalPage';

// Admin
import AdminLayout           from './admin/components/AdminLayout';
import Dashboard             from './admin/pages/Dashboard';
import Submissions           from './admin/pages/Submissions';
import SectionSettingsPage   from './admin/components/SectionSettingsPage';
import InviteTable           from './admin/components/InviteTable';

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="submissions" element={<Submissions />} />
            <Route path="sections"   element={<SectionSettingsPage />} />
            <Route path="invites"    element={<InviteTable />} />
          </Route>

          <Route path="/legal" element={<LegalPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
